import React, { FunctionComponent, useEffect } from 'react';
import { connect } from 'react-redux';
import { parse } from 'query-string';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { IBindingCallback1 } from '../../common/models/callback';
import LoaderWrapper from '../../components/LoaderWrapper';
import { getObject } from '../../common/helpers/storageHelper';
import { completeLeverIntegrationRoutine } from './routines';
import { Integration } from '../../common/enums/Integration';

interface IProps extends RouteComponentProps {
  completeLeverIntegration: IBindingCallback1<string>;
}

const IntegrationsCallback: FunctionComponent<IProps> = ({ location, completeLeverIntegration }) => {
  const { code, state } = parse(location.search);
  const storedState = getObject('OAuthState');
  const isStateEqual = state === storedState?.value;

  const completeIntegration = () => {
    switch (storedState.key) {
      case Integration.Lever:
        completeLeverIntegration(code as string);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (code && isStateEqual) {
      completeIntegration();
    } else {
      window.opener?.location.reload();
      window.close();
    }
  }, []);

  return (
    <LoaderWrapper loading={Boolean(code)} />
  );
};

const mapDispatchToProps = {
  completeLeverIntegration: completeLeverIntegrationRoutine
};

export default connect(null, mapDispatchToProps)(withRouter(IntegrationsCallback));
